interface EnkBreadcrumbProps {
  location: string
  onNavigate: (newLocation: string) => void
  rootName?: string
}

export const LOCATION_SEPARATOR = "|"

export default function EnkBreadcrumb({ location, onNavigate, rootName = "Root" }: EnkBreadcrumbProps) {
  if (!location)
    return (
      <nav className="mb-2 text-sm text-gray-500" aria-label="Breadcrumb">
        <span className="font-semibold text-primary cursor-pointer" onClick={() => onNavigate("")}>
          {rootName}
        </span>
      </nav>
    )
  const parts = location.split(LOCATION_SEPARATOR)
  const crumbs = parts.map((part, idx) => {
    const crumbLocation = parts.slice(0, idx + 1).join(LOCATION_SEPARATOR)
    return { name: part, location: crumbLocation }
  })
  return (
    <nav className="mb-2 text-sm text-gray-500" aria-label="Breadcrumb">
      <span className="font-semibold text-primary cursor-pointer" onClick={() => onNavigate("")}>
        {rootName}
      </span>
      {crumbs.map((crumb, idx) => (
        <span key={crumb.location}>
          <span className="mx-1">/</span>
          {idx === crumbs.length - 1 ? (
            <span className="text-gray-900 font-semibold">{crumb.name}</span>
          ) : (
            <span className="text-primary cursor-pointer hover:underline" onClick={() => onNavigate(crumb.location)}>
              {crumb.name}
            </span>
          )}
        </span>
      ))}
    </nav>
  )
}
